import React, { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import EventRoutes from './EventRouter';
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import StyleVariables from '../StyleVariables/StyleVariables';
import I18nSwitcher from '../I18nSwitcher';
import { useDemoEventId } from '../../data/hooks/ui/useDemoEventId';
import SidePanel from '../sidepanel/SidePanel';

function DemoRouter(props) {
    const {} = props,
        eventId = useDemoEventId();

    // Mirrors Router.jsx: reset side panel state (e.g. eventMap/floorplan) on every navigation,
    // otherwise the side panel Switch keeps matching the event map route on any sub-path.
    useEffect(() => app.history.listen((location) => app.store.dispatch(app.actions.ui.navigation(location.pathname))), []);

    return (
        <Router history={app.history}>
            <SidePanel containerSelector="#splitScreen" />
            <StyleVariables />
            <I18nSwitcher />
            <Switch>
                <Route path="/preview" render={({ location }) => {
                    Sentry.captureMessage('Preview redirect used', { level: 'warning', extra: { pathname: location.pathname } });
                    return <Redirect to={{ ...location, pathname: location.pathname.replace(/^\/preview/, '') || '/' }} />;
                }} />
                <Route path="/events/:eventId" component={EventRoutes} />
                <Redirect to={`/events/${eventId}`} />
            </Switch>
        </Router>
    );
}

export default DemoRouter;
